/* unplugin-vue-components disabled */import { render } from "./CashPage.vue?vue&type=template&id=70597d40&scoped=true"
import script from "./CashPage.vue?vue&type=script&lang=js"
export * from "./CashPage.vue?vue&type=script&lang=js"

import "./CashPage.vue?vue&type=style&index=0&id=70597d40&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70597d40"]])

export default __exports__